import CustomerCustomerProfile from './CustomerCustomerProfile'

export default CustomerCustomerProfile
